import React from 'react';
import PropTypes from 'prop-types';

import Safe from './Safe';

const SubEvent = ({ workflows }) => {
  const maxWorkFlow = Math.max(...Object.keys(workflows).filter(x => x in [1, 2, 3, 4]));
  const num = maxWorkFlow || 0;
  const subEvent = workflows[num] || null;

  return (
    <div className='sub-event'>
      <span
        style={{
          width: '20%',
          display: 'inline-block',
          verticalAlign: 'top',
        }}
      >
        <span
          className='number-bubble'
        >
          {num}
        </span>
      </span>
      <span
        style={{
          width: '80%',
          display: 'inline-block',
          verticalAlign: 'top',
          paddingTop: '4px',
          fontSize: '18px',
        }}
      >
        <Safe
          type='div'
          className='sub-event-text'
          text={subEvent}
        />
      </span>
    </div>
  );
};

SubEvent.propTypes = {
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]), // eslint-disable-line
  workflows: PropTypes.any, // eslint-disable-line
  value: PropTypes.any, // eslint-disable-line
};

SubEvent.defaultProps = {
  date: new Date(),
  value: '',
};

export default SubEvent;



// WEBPACK FOOTER //
// ./src/views/Components/SubEvent.js